
export enum TipoNotificacaoMobileEnum {
  To = 'To',
  Condition = 'Condition',
}
